import React from 'react';
import { Box, Typography } from '@mui/material';
import DurationBar from './DurationBar';

interface LeadTimeSummaryProps {
  productionDuration?: number;
  shippingDuration?: number;
  processingDuration?: number;
}

const LeadTimeSummary: React.FC<LeadTimeSummaryProps> = ({
  productionDuration = 0,
  shippingDuration = 0,
  processingDuration = 0
}) => {
  const totalDuration = productionDuration + shippingDuration + processingDuration;

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1, mt: 1, p: 3, borderTop: '1px solid', borderColor: 'divider', fontWeight: 'bold' }}>
      <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
        <Typography variant="body2">Total Lead Time</Typography>
        <Typography variant="body2">{totalDuration} days</Typography>
      </Box>
      <DurationBar
        productionDuration={productionDuration}
        shippingDuration={shippingDuration}
        processingDuration={processingDuration}
      />
    </Box>
  );
};

export default LeadTimeSummary;
